import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Scrollbars } from "react-custom-scrollbars";
import { store } from "../store";
import { queryGetBulkSmsContactTagList } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import Row from "./Row";
import CreateTag from './CreateTagWithQueryMutation'
import styled, { css } from 'styled-components'
import Button from "module-common/Button";
import { mutationDeleteTag } from "../../Apollo";

const ListGraphql = compose(
  graphql(queryGetBulkSmsContactTagList, {
    name: 'tagList',
    fetchPolicy: 'network-only'
  }),
  graphql(mutationDeleteTag, {
    name: 'deleteTag'
  })
)(
  observer(
    class ListView extends Component {
      state = {
        isCreatingTag: false,
        isEdittingTag: false,
        tag: null
      }

      closeCreatePanel = () => {
        this.setState(state => ({...state, isCreatingTag: false, isEdittingTag: false, tag: null }))
      }

      editTag =  (tag) => {
        this.setState(state => ({...state, isCreatingTag: false, isEdittingTag: true, tag: tag}))
      }

      deleteTag = async (tag) => {
        const isOk = window.confirm(`"Are you sure to delete (${tag.displayName})? Deleting tag will not delete the associated contacts"`)
        if(isOk) {
            try {
                const result = await this.props.deleteTag({
                    variables: {
                        tagId: tag.id
                    },
                    refetchQueries: ['getBulkSmsContactTagList', 'queryGetBulkSmsContactTagList']
                })
            } catch(e) {
                console.log(e)
            }
        }
    }

      render() {
        const { tagList: { loading, getBulkSmsContactTagList } } = this.props;
        const { isCreatingTag, isEdittingTag } = this.state
        const renderList = !loading && getBulkSmsContactTagList && <Scrollbars
          ref={ref => (this.scroller = ref)}
        >
          {getBulkSmsContactTagList.map((item, index) => {
            return <Row 
              {...item} 
              index={index + 1} 
              onEdit={() => this.editTag(item)}
              onDelete={() => this.deleteTag(item)}
            />
          })}
        </Scrollbars>
        const content = <Content>
            <ListWrapper>
                <ListTitle>
                    <Index>No.</Index>
                    <Name>Name</Name>
                    <Toolbox></Toolbox>
                </ListTitle>
                <ListBody>
                  {renderList}
                </ListBody>
            </ListWrapper>
        </Content>

        return (
          <React.Fragment>
            <CreateTagPanel>
              {!isEdittingTag && !isCreatingTag && <Button
                color="blue"
                size="large"
                border
                onClick={() => {
                  this.setState(state => ({
                    ...state, 
                    isCreatingTag: !state.isCreatingTag
                  }))
                }}
              >
                Create Tag
              </Button>}
            </CreateTagPanel>  
            {isCreatingTag && <CreateTag 
              onSuccess={() => setTimeout(() => { this.closeCreatePanel() }, 350)} 
              onCancel={() => setTimeout(() => { this.closeCreatePanel() }, 350)} 
            />}
            {isEdittingTag && <CreateTag 
              tagId={this.state.tag.id}
              displayName={this.state.tag.displayName}
              onSuccess={() => setTimeout(() => { this.closeCreatePanel() }, 350)} 
              onCancel={() => setTimeout(() => { this.closeCreatePanel() }, 350)}
            />}
            {loading && <LoadingPanel />}
            {!loading && getBulkSmsContactTagList && (!isCreatingTag) && !isEdittingTag && content}                
          </React.Fragment>
        );
      }
    }
  )
);

export default observer(
  class List extends Component {
    render() {
      return <ListGraphql />;
    }
  }
);

const CreateTagPanel = styled.div`
  height: 50px;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid #d2d3d5;
`

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* overflow: scroll; */
`;

const Header = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d2d3d5;
`;

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #087cbc;
`;

const Back = styled.span`
  cursor: pointer;
`;

const Content = styled.div`
  padding: 10px 20px;
`;

const FilterWrapper = styled.div`
  width: 400px;
`;

const ListWrapper = styled.div`
  margin-top: 10px;
`;

const ListTitle = styled.div`
  background: #20445a;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
`;

const ListBody = styled.div`
  padding: 5px 10px;
  height: calc(74vh);
  width: 100%;
`

const Index = styled.div`
  margin-left: 10px;
  flex: 3;
`;

const Name = styled.div`
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Toolbox = styled.div`
  flex: 3;
`;

const SocialMedia = styled.div`
  flex: 2;
  text-align: center;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;




// WEBPACK FOOTER //
// ./src/module-bulk-sms/tags/ListWithQuery.js